var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3999 5.89998H6.60002V1.09996C6.60002 0.768835 6.33118 0.5 5.99995 0.5C5.66882 0.5 5.39998 0.768835 5.39998 1.09996V5.89998H0.599962C0.268835 5.89998 0 6.16882 0 6.49995C0 6.83118 0.268835 7.10002 0.599962 7.10002H5.39998V11.8999C5.39998 12.2312 5.66882 12.5 5.99995 12.5C6.33118 12.5 6.60002 12.2312 6.60002 11.8999V7.10002H11.3999C11.7312 7.10002 12 6.83118 12 6.49995C12 6.16882 11.7312 5.89998 11.3999 5.89998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.460e45683e993d2a07835a1227655575.svg";
export { ForwardRef as ReactComponent };